__turbopack_context__.v({
  "enterButtonContainer": "Homepage-Footer-module__jggDYW__enterButtonContainer",
  "footerContent": "Homepage-Footer-module__jggDYW__footerContent",
  "footerLogos": "Homepage-Footer-module__jggDYW__footerLogos",
  "footerSection": "Homepage-Footer-module__jggDYW__footerSection",
});
